<div class="text-center">
  @if (tooltip()) {
  <p class="cursor-pointer underline underline-offset-4 decoration-dotted decoration-slate-300" tp="{{tooltip()}}">
    {{key()}}
  </p>
  }
  @else {
  <p>
    {{key()}}
  </p>
  }
  @if (value()) {
  <p class="text-green-600">
    {{value()}}
  </p>
  }
</div>